import { useQuery } from "convex/react";

import { api } from "@convex/_generated/api";

/**
 * Subscribes to a single workflow (spec) by id, joined with its current
 * version — the same `{ spec, version }` shape `useSpec` returns (see
 * `api.specs.getById`).
 *
 * `specId` is an untrusted string (the tail of the `/workflows/$slug`
 * route param, via `parseSpecIdFromSlug`) — the server `normalizeId`s it
 * and degrades garbage to `null`.
 *
 * Tri-state, distinguished for the caller:
 *  - `undefined` from the query → still loading (`isLoading: true`,
 *    `result: undefined`).
 *  - `null` from the query → the spec is missing, foreign-owned, or the
 *    id token is malformed; ownership never leaks existence
 *    (`isLoading: false`, `result: null`).
 *  - a value → the workflow (`isLoading: false`).
 */
export function useSpecById({ specId }: { specId: string }) {
  const result = useQuery(api.specs.getById, { specId });
  return {
    result,
    isLoading: result === undefined,
  };
}
